<template>
  <div>
    <modal
      v-if="changeMimkModal"
      :title="$t('mc.modals.titles.changeMimk')"
      @close="closeChangeMimkModal"
      width="400px">
      <template v-slot:body>
        <v-select
          v-model="selectedMimk"
          :options="$store.state.user.mimkList"
          :loading="!$store.state.user.mimkListLoaded"
          :placeholder="$t('mc.placeholders.selectMimkFromList')"
          :clearable="false"
          @input="setMimk"></v-select>
      </template>
      <template v-slot:footer>
        <button
          class="btn btn_autowidth btn_blue"
          @click="changeMimk">
          {{$t('mc.supervisor.buttons.changeMimk')}}
        </button>
      </template>
    </modal>
    <header-page 
      ref="headerPage"
      :namePage="$t('pagesTitles.mc')"
      :isSearchInput="true" 
      :links="$store.state.headerLinks.supervisorMcLinks"
      @clearSearchInput="clearSearchInput"
      @searchByAmoId="searchByAmoId"
    />
    <div class="content">
      <loader v-if="isLoad"/>
      <template v-else>
      <datepicker
        calendar-class="my-datepicker_calendar"
        :clearable="false"
        class="datepicker_mimk"
        v-model="searchDate"
        format="DD.MM.YYYY"
        valueType="format"
        :lang="globalSettingCalendar">
        <i slot="icon-calendar">
          <inline-svg :src="require(`@/assets/svg/picker-calendar.svg`)"/>  
        </i>
      </datepicker>
      <template v-if="tableDataFinished.row.length">
        <base-table
          :head="tableDataFinished.head"
          :columnTemplates="tableDataFinished.sizeColumn">
          <base-table-row
              v-for="(element) of allMkWithSubArrays[this.page-1]"
              :key="`${element.mcId}finished`"
              :columnTemplates="tableDataFinished.sizeColumn"
              :style="bookingsTags && Array.isArray(bookingsTags[element.mcId]) && bookingsTags[element.mcId].length ? 'position: relative; padding-bottom: 40px;' : ''"
          >
            <base-table-column class="table-column_elipsis">
              <Copy :text="element.amoId" :textMessage="$t('mc.toasts.copyLink')"/>
              <a :href="element.amoId" target="blank">{{element.amoIdOnlyId}}</a>  
            </base-table-column>
            <base-table-column>
              <router-link :to="`/master-classes/detail/${element.mcId}`" target="_blank" v-tooltip="$t('mc.tooltips.detailMc')">
                <inline-svg
                  class="icon-in-mk"
                  :src="require(`@/assets/svg/link.svg`)"
                />
              </router-link>
            </base-table-column>
            <base-table-column>
              <div>
                <span>{{element.date.start}}</span>
                <br />
                <span>{{element.date.hour}}</span>
              </div>
            </base-table-column>
            <base-table-column>
              <a @click="openChangeMimkModal(element.mcId)" v-tooltip="getMimkTags(element.mimkId)">{{element.mimk}}</a>
            </base-table-column>
            <base-table-column>
              <div class="cell-content__status">
                <inline-svg
                  v-if="element.status.svgName"
                  :src="require(`@/assets/svg/${element.status.svgName}.svg`)"
                  class="cell-content__status-icon"
                />
                <span>      
                  {{element.status_translated}}
                  <br>
                  <span
                    v-if="element.hour_before_confirmed"
                    class="table-column-status_hour-confirm">{{$t('mc.tables.cols.confirmBeforeHour')}}
                  </span>
                </span>
              </div>
            </base-table-column>
            <base-table-column>        
              <p>{{element.comment}}</p>
            </base-table-column>
            <div style="position: absolute;bottom: 0;padding-left: 15px;" v-if="bookingsTags && Array.isArray(bookingsTags[element.mcId])">
              <Tags :show-title="false" :modify-ability="false" tags-wrapper-style="width: calc(100vw - 400px);" :prop-tags="bookingsTags[element.mcId]"></Tags>
            </div>
          </base-table-row>
        </base-table>
        <div class="pagination">
          <Count @changeCountsOnPage="changeCountsOnPage"/>
          <pagination
            v-model="page"
            :records="tableDataFinished.row.length"
            :per-page="perPage"
            :options="{texts: false}"
            @paginate = "setPage"
          />
        </div>
      </template>
      <div class="empty-mk-title" v-else>{{$t('mc.supervisor.titles.finishedMcNotFound')}}</div>
      </template>
    </div>
  </div>
</template>


<script>
import createSubarrays from "@/helpers/createSubarrays"
import apiBooking from '@/api/master-classes/booking'
import {Supervisor} from "@/helpers/tableConstructor"
import scrollToContent from "@/helpers/scrollToContent"
import Copy from '@/components/UI/Copy'
import Count from '@/components/UI/CountElementsOnPage'
import globalSettingCalendar from '@/helpers/globalSettingCalendar'
import Tags from "@/components/Supervisor/Tags"
import apiTags from "@/api/tags";
export default {
  components: {
    Copy,
    Count,
    Tags,
  },
  data() {
    return {
      globalSettingCalendar,
      perPage: 10,
      isLoad: true,
      searchDate: '',
      finishedData: [],
      tableDataFinished: {
        head: [
          this.$t('mc.tables.titles.client'),
          '',
          this.$t('mc.tables.titles.date'),
          this.$t('mc.tables.titles.mimk'),
          this.$t('mc.tables.titles.status'),
          this.$t('mc.tables.titles.comment')],
        sizeColumn: '4fr 16px 1.5fr 1.5fr 1.5fr 4fr',
        row: {}
      },
      allMkWithSubArrays: [],
      page: 1,
      selectedMimk: '',
      modalMcId: '',
      changeMimkModal: false
    }
  },
 async created() {
   if (!localStorage.getItem('countsOnPage')) {
      this.perPage = 10
    } else {
      this.perPage = JSON.parse(localStorage.getItem('countsOnPage')).value
    }
    this.searchDate = this.$dayjs(new Date()).format('DD.MM.YYYY')
    this.isLoad = false
  },
  computed: {
    bookingsTags() {
      return this.$store.state.tags.bookingsTagsObject
    },
    mimksTags() {
      return this.$store.state.tags.mimksTagsObject
    },
  },
  methods: {
    getMimkTags(mimkId) {
      if (this.mimksTags && this.mimksTags[mimkId]) {
        return this.mimksTags[mimkId].map(tag => tag.name).join(', ')
      }

      return null
    },
    setPage() {
      scrollToContent(this.$el.querySelector('.content'))
    },
    async changeCountsOnPage(value) {
      this.perPage = value
      await this.buildTable(this.searchDate)
    },
    setMimk(mimk) {
      this.selectedMimk = mimk
    },
    closeChangeMimkModal() {
      this.changeMimkModal = false
    },
    openChangeMimkModal(mcId) {
      this.modalMcId = mcId
      this.changeMimkModal = true
    },
    async clearSearchInput() {
      await this.buildTable(this.searchDate)
    },
    async searchByAmoId(searchedString) {
      this.page = 1
      this.isLoad = true
      const searchedMasterClasses = await apiBooking.getMkByLink(searchedString)
      if (!searchedMasterClasses) {
        this.isLoad = false
        return
      }
      this.initTags(searchedMasterClasses.finished)
      this.tableDataFinished.row = new Supervisor(searchedMasterClasses.finished, true, true)
      this.allMkWithSubArrays = createSubarrays(this.perPage, this.tableDataFinished.row )
      this.isLoad = false
    },
    initTags(bookingsArray = []) {
      if (bookingsArray.length) {
        const bookingIds = bookingsArray.map(booking => booking.id)
        const mimkIds = Array.from(new Set(bookingsArray.map(booking => booking.mimk).filter(mimk => !!mimk)))
        apiTags.getBookingsTags(bookingIds, true)
        apiTags.getMimksTags(mimkIds, this.$store.state.user.segment.id, true)
      }
    },
    async buildTable(date) {
      this.isLoad = true
      this.page = 1
      await this.getAllBookings(date)
      this.initTags(this.finishedData)

      this.tableDataFinished.row = new Supervisor(this.finishedData, true, true)
      this.allMkWithSubArrays = createSubarrays(this.perPage, this.tableDataFinished.row)
      this.isLoad = false
    },
    async getAllBookings(date) {
      const mkList = await apiBooking.getBookingsAll(this.$dayjs(date, 'DD.MM.YYYY').format('YYYY-MM-DD') + ' 00:00')
      this.finishedData = [ ...mkList.finished ]
      this.isLoad = false
    },
    async changeMimk() {
      this.isLoad = true
      this.changeMimkModal = false
      await apiBooking.updateBooking(this.modalMcId, {
        mimk: this.selectedMimk.id,
        mimk_name: this.selectedMimk.label
      })
      await this.buildTable(this.searchDate)
      this.isLoad = false
    }
  },
  watch: {
    async searchDate(date) {
      this.$refs.headerPage.clearAmoId()  
      await this.buildTable(date)
    }
  }
}
</script>
